export const ChevronDownThinIcon = ({
  title = "Expand",
  width = 24,
  height = 24,
  ...props
}: IconProps) => {
  return (
    <svg
      data-testid="chevron-down-thin-icon"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={props.fill ? props.fill : "none"}
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <title>{title}</title>
      <path
        d="M4 8L12 16L20 8"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
